
const styles = {
  versionDetails: {
    position: 'relative',
    height: { xs: 'calc(100vh - 56px)', sm: 'calc(100vh - 75px)' },
    padding: 2,
    boxSizing: 'border-box',
    backgroundColor: '#f0f0f0',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    gap: 2,
  },

  headerRow: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  pageTitle: {
    fontFamily: 'Source Sans Pro',
    fontWeight: 600,
    fontSize: { xs: '28px', sm: '38px' },
    lineHeight: '100%',
    color: '#5236AB',
  },
};

export default styles;
